import PropTypes from "prop-types"
import { Person } from "@mui/icons-material"
import { connect } from "react-redux"
import { get } from "lodash"
import Header from "modules/home-header"

function TokenDatasetsHeader({ account, name }) {
  const tokenName = name ? `Dataset Entitlements: ${name}` : "Dataset Entitlements"
  return <Header Icon={Person} title={tokenName} account={account} />
}

TokenDatasetsHeader.propTypes = {
  account: PropTypes.string.isRequired,
  name: PropTypes.string,
}

export default connect(state => ({ name: get(state, "global.data.token.data.token.name") }), null)(TokenDatasetsHeader)
